/**
 * Engraving Checkbox UI
 * Injects the complimentary engraving checkbox after variant selects on PDPs.
 * Respects window.theme.settings.engravable flag set in layout/theme.liquid.
 */
(function () {
  'use strict';

  // ── PDP CHECKBOX ─────────────────────────────────────────────────────────────

  function initEngravingCheckbox() {
    if (!window.theme || !window.theme.settings || !window.theme.settings.engravable) return;

    var variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    if (document.getElementById('engraving-section')) return;

    var sectionId = variantSelects.getAttribute('data-section') || '';
    var formId = 'product-form-' + sectionId;

    var section = document.createElement('div');
    section.className = 'product-form__input engraving-section';
    section.id = 'engraving-section';
    section.innerHTML = [
      '<label class="engraving-section__toggle" for="engraving-toggle" style="display:flex;align-items:center;gap:10px;cursor:pointer;">',
        '<input type="checkbox" id="engraving-toggle" class="engraving-toggle">',
        '<span>Add complimentary engraving (Optional)</span>',
        '<a href="/pages/engraving" target="_blank" class="engraving-learn-more" style="display:inline-flex;align-items:center;gap:4px;font-size:1em;text-decoration:none;">',
          '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
          'Learn More',
        '</a>',
      '</label>',
      '<div class="engraving is-hidden" id="engraving-details" style="margin-top:16px;">',
        '<div class="product-form__input product-form__input--block">',
          '<div class="form__label">Font: <span class="form__label__value" id="engraving-font-label">Bold</span></div>',
          '<input type="radio" id="engraving-bold" name="properties[Font]" value="Bold" form="' + formId + '">',
          '<label for="engraving-bold" style="margin-right:16px;"><span>Bold</span></label>',
          '<input type="radio" id="engraving-slim" name="properties[Font]" value="Slim" form="' + formId + '">',
          '<label for="engraving-slim"><span>Slim</span></label>',
        '</div>',
        '<div class="product-form__input product-form__input--block" style="margin-top:16px;">',
          '<label for="engraving-text" class="form__label">Engraving text: <span class="form__label__value">(Up to 6 characters)</span></label>',
          '<input id="engraving-text" type="text" name="properties[Engraving text]" form="' + formId + '" maxlength="6" class="product-information--line-item--text">',
        '</div>',
      '</div>'
    ].join('');

    variantSelects.insertAdjacentElement('afterend', section);

    var checkbox = document.getElementById('engraving-toggle');
    var details  = document.getElementById('engraving-details');
    var boldRadio = document.getElementById('engraving-bold');
    var slimRadio = document.getElementById('engraving-slim');
    var textInput = document.getElementById('engraving-text');
    var fontLabel = document.getElementById('engraving-font-label');

    function updateFontLabel() {
      if (boldRadio && boldRadio.checked) fontLabel.textContent = 'Bold';
      else if (slimRadio && slimRadio.checked) fontLabel.textContent = 'Slim';
    }

    if (boldRadio) boldRadio.addEventListener('change', updateFontLabel);
    if (slimRadio) slimRadio.addEventListener('change', updateFontLabel);

    checkbox.addEventListener('change', function () {
      if (this.checked) {
        details.classList.remove('is-hidden');
        if (boldRadio) { boldRadio.checked = true; boldRadio.required = true; }
        if (textInput) textInput.required = true;
        updateFontLabel();
      } else {
        details.classList.add('is-hidden');
        if (boldRadio) { boldRadio.required = false; boldRadio.checked = false; }
        if (slimRadio) { slimRadio.required = false; slimRadio.checked = false; }
        if (textInput) { textInput.required = false; textInput.value = ''; }
      }
    });
  }

  // ── CART: STRIP "NO ENGRAVING" FROM VARIANT TITLE TEXT ───────────────────────

  var NO_ENGRAVE_RE = /[\s,\/]*no\s+engraving[\s,\/]*/gi;

  function stripNoEngravingFromNode(node) {
    if (node.nodeType !== Node.TEXT_NODE) return;
    if (!node.textContent || !/no\s+engraving/i.test(node.textContent)) return;
    var parent = node.parentElement;
    if (parent && (parent.tagName === 'INPUT' || parent.tagName === 'TEXTAREA' || parent.tagName === 'SELECT')) return;
    node.textContent = node.textContent.replace(NO_ENGRAVE_RE, '').trim();
  }

  function walkAndStrip(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      stripNoEngravingFromNode(node);
    }
  }

  function hideNoEngravingFromCart() {
    var containers = document.querySelectorAll('#cart-drawer, .cart-drawer, [id*="cart"], [class*="cart-item"], [class*="line-item"]');
    if (containers.length) {
      containers.forEach(function(c) { walkAndStrip(c); });
    } else {
      walkAndStrip(document.body);
    }
  }

  var cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) walkAndStrip(node);
      });
    });
  });

  function startCartObserver() {
    cartObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ── INIT ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initEngravingCheckbox();
      hideNoEngravingFromCart();
      startCartObserver();
    });
  } else {
    initEngravingCheckbox();
    hideNoEngravingFromCart();
    startCartObserver();
  }

  document.addEventListener('cart:updated', hideNoEngravingFromCart);
  document.addEventListener('cart:refresh', hideNoEngravingFromCart);
})();
